import { useState } from "react";
import { motion } from "framer-motion";
import { Wind } from "lucide-react";
import { useBoxBreathing } from "@/hooks/useBoxBreathing";
import { BreathCircle, GroundingList, CrisisResources } from "@/components/panic/PanicParts";

export function PanicSOS({ onDone }) {
  const { phase, count } = useBoxBreathing();
  const [done, setDone] = useState([]);

  return (
    <motion.div initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
      className="rounded-3xl p-5 bg-stone-900 text-stone-100 space-y-4" data-testid="panic-sos-card">
      <div className="flex items-center gap-2 text-amber-300 text-xs font-bold uppercase tracking-widest">
        <Wind className="w-4 h-4" /> You're safe. Let's slow this down together.
      </div>
      <BreathCircle phase={phase} count={count} />
      <GroundingList done={done} onChange={setDone} />
      <button type="button" data-testid="panic-steadier-btn" onClick={onDone} className="text-xs font-semibold text-stone-300 hover:text-white underline underline-offset-2">
        I feel steadier — hide this
      </button>
      <CrisisResources />
    </motion.div>
  );
}
